import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function SalesSection() {
  const {
    t
  } = useLanguage();
  const [showFloorPlan, setShowFloorPlan] = useState(false);
  return <section id="prodej" className="py-24 md:py-32 bg-charcoal-800 relative bg-grain" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-161">
        <div className="text-center max-w-4xl mx-auto mb-20" data-id="element-162">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-163">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading text-cream mb-6" data-id="element-164">
              {t.sales.heading}
            </h2>
            <p className="text-xl md:text-2xl text-cream/70 font-light italic" data-id="element-165">
              {t.sales.subtitle}
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-166">
          {t.sales.features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="bg-charcoal-900 p-8 md:p-10 border-t-2 border-gold relative group" data-id="element-167">
              <div className="absolute inset-0 bg-gradient-to-b from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-168"></div>
              <h3 className="text-2xl font-heading text-cream mb-4 relative z-10" data-id="element-169">
                {feature.title}
              </h3>
              <p className="text-cream/70 leading-relaxed font-light relative z-10" data-id="element-170">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="bg-charcoal-900 border border-charcoal-700 p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-171">
          <div className="flex-1" data-id="element-172">
            <h4 className="text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-4" data-id="element-173">
              {t.sales.techLabel}
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-cream mb-8" data-id="element-174">
              <div data-id="element-175">
                <span className="block text-cream/50 text-sm mb-1" data-id="element-176">
                  {t.sales.area}
                </span>
                <span className="text-xl font-heading" data-id="element-177">{t.sales.areaVal}</span>
              </div>
              <div data-id="element-178">
                <span className="block text-cream/50 text-sm mb-1" data-id="element-179">
                  {t.sales.layout}
                </span>
                <span className="text-xl font-heading" data-id="element-180">
                  {t.sales.layoutVal}
                </span>
              </div>
              <div data-id="element-181">
                <span className="block text-cream/50 text-sm mb-1" data-id="element-182">
                  {t.sales.floor}
                </span>
                <span className="text-xl font-heading" data-id="element-183">{t.sales.floorVal}</span>
              </div>
              <div data-id="element-184">
                <span className="block text-cream/50 text-sm mb-1" data-id="element-185">
                  {t.sales.condition}
                </span>
                <span className="text-xl font-heading" data-id="element-186">
                  {t.sales.conditionVal}
                </span>
              </div>
            </div>

            <div className="mt-8 border-t border-charcoal-700 pt-8" data-id="element-187">
              <button onClick={() => setShowFloorPlan(!showFloorPlan)} className="flex items-center gap-3 text-sm tracking-[0.2em] uppercase text-gold font-semibold hover:text-gold-hover transition-colors duration-300 group" data-id="element-188">
                <span data-id="element-189">{t.sales.floorPlan}</span>
                <motion.span animate={{
                rotate: showFloorPlan ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="inline-block" data-id="element-190">
                  ▼
                </motion.span>
              </button>
              {showFloorPlan && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden mt-4" data-id="element-191">
                  <div className="w-full bg-cream/5 p-4 border border-cream/10 rounded-sm" data-id="element-192">
                    <img src="https://cdn.magicpatterns.com/uploads/dySHvmKCk97xotGPYaCkeN/byt.jpg" alt="Půdorys bytu" className="w-full h-auto object-contain mix-blend-screen opacity-90 hover:opacity-100 transition-opacity" data-id="element-193" />
                  </div>
                </motion.div>}
            </div>
          </div>

          <div className="w-full md:w-auto self-start md:self-center mt-8 md:mt-0" data-id="element-194">
            <a href="#kontakt" className="inline-block w-full md:w-auto px-8 py-4 bg-gold text-charcoal-900 text-sm tracking-widest uppercase font-semibold hover:bg-gold-hover transition-colors duration-300 text-center" data-id="element-195">
              {t.sales.cta}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}